import React from 'react'

export interface InvoiceBreakdownProps {
  containerClass?: string
  size?: InvoiceBreakdownSize
  divider?: React.ReactNode
  preliminary?: boolean
}

export enum InvoiceBreakdownSize {
  small,
  big,
}
